(() => {
  if (window.rvMeta) return;
  const config = document.getElementById('rv-meta-pixel');
  const pixelId = config && config.dataset.pixelId;
  if (!pixelId) return;

  const queue = [];
  let loaded = false;
  let revoked = false;

  const marketingAllowed = () => {
    try { return Boolean(window.Shopify?.customerPrivacy?.marketingAllowed?.()); } catch (_) { return false; }
  };
  const newEventId = name => name + '-' + (window.crypto?.randomUUID ? window.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
  const currency = () => window.Shopify?.currency?.active || 'EUR';

  function flush() {
    if (!loaded || revoked) return;
    while (queue.length) {
      const [name, params, eventID] = queue.shift();
      window.fbq('trackSingle', pixelId, name, params, { eventID });
    }
  }

  // Charge le pixel uniquement après l'accord « Publicités personnalisées ».
  // PageView, AddToCart, InitiateCheckout et Purchase restent envoyés par Shopify (canal Facebook & Instagram) :
  // ce script n'ajoute que le ViewContent de la page de commande, pour éviter tout doublon.
  function load() {
    if (loaded) {
      if (revoked) { window.fbq('consent', 'grant'); revoked = false; }
      flush();
      return;
    }
    loaded = true;
    if (!window.fbq) {
      const n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!window._fbq) window._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('set', 'autoConfig', false, pixelId);
    window.fbq('init', pixelId);
    flush();
  }

  function revoke() {
    queue.length = 0;
    if (loaded && !revoked) { window.fbq('consent', 'revoke'); revoked = true; }
  }

  function track(name, params) {
    if (revoked) return false;
    queue.push([name, params || {}, newEventId(name)]);
    if (!loaded && marketingAllowed()) load(); else flush();
    return loaded;
  }

  document.addEventListener('visitorConsentCollected', event => {
    if (event.detail && event.detail.marketingAllowed) load(); else revoke();
  });

  let attempts = 0;
  (function waitForConsent() {
    if (loaded) return;
    if (marketingAllowed()) { load(); return; }
    if (++attempts < 60) setTimeout(waitForConsent, 500);
  })();

  // ViewContent : sur la page de choix du pyjama, que Shopify ne traite pas comme une fiche produit.
  async function viewContent() {
    const root = document.querySelector('[data-rv-order][data-product]');
    if (!root) return;
    try {
      const base = window.Shopify?.routes?.root || '/';
      const product = await fetch(base + 'products/' + encodeURIComponent(root.dataset.product) + '.js').then(response => response.json());
      const wanted = new URLSearchParams(location.search).get('variant');
      const variant = product.variants.find(v => String(v.id) === wanted) || product.variants.find(v => v.available) || product.variants[0];
      // Même format que les événements envoyés par Shopify (identifiant de variante), pour que Meta les rapproche.
      track('ViewContent', {
        content_ids: [String(variant.id)],
        content_type: 'product',
        content_name: product.title + ' - ' + variant.title,
        content_category: product.type || undefined,
        contents: [{ id: String(variant.id), quantity: 1 }],
        value: variant.price / 100,
        currency: currency()
      });
    } catch (_) {}
  }

  window.rvMeta = { track };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', viewContent); else viewContent();
})();
